export enum RemoteConfigKeys {
  NEWEST_VERSION = 'newest_version',
  AVAILABLE_VERSIONS = 'available_versions',
  FEATURE_FLAGS_MANAGEMENT = 'feature_flags_management'
}
